exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "html,\r\nbody,\r\n#app{\r\n    margin: 0;\r\n    padding: 0;\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\n", "", {"version":3,"sources":["/Users/fyk/Desktop/workSpace/workData/spx/NkChoose/NKYXGLHT/src/assets/css/global.css"],"names":[],"mappings":"AAAA;;;IAGI,UAAU;IACV,WAAW;IACX,aAAa;IACb,YAAY;CACf","file":"global.css","sourcesContent":["html,\r\nbody,\r\n#app{\r\n    margin: 0;\r\n    padding: 0;\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--5-1!./node_modules/postcss-loader/lib??ref--5-2!./src/assets/css/global.css
// module id = mLZY
// module chunks = 3